import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { AppliedFilter, BaseFilter } from '@shared/components/filters/Domain/filter.model';
import { NgForOf, NgIf } from '@angular/common';
import { FilterItemComponent } from '@shared/components/filters/Components/filter-item/filter-item.component';
import { SharedModule } from '@shared/shared.module';
import { DividerModule } from 'primeng/divider';
import { FilterService } from '@shared/components/filters/Application/Services/filter.service';
@Component({
  selector: 'app-filter-selector',
  standalone: true,
  imports: [NgIf, NgForOf, FilterItemComponent, SharedModule, DividerModule, FilterItemComponent],
  templateUrl: './filter-selector.component.html',
  styleUrl: './filter-selector.component.scss',
})
export class FilterSelectorComponent implements OnInit {
  @Input() filters!: BaseFilter[];
  @Input() removeFilterId: string | null | undefined;
  @Input() resetFiltersTrigger = false;
  @Input() itCloses!: boolean;
  @Output() applyFilters = new EventEmitter<AppliedFilter[]>();
  @Output() emitSearch = new EventEmitter();

  selectedFilter: Record<string, AppliedFilter> = {}; // Single source of truth
  selectedFilterId: string | null = null;

  constructor(public filterService: FilterService) {}

  ngOnInit() {
    //Load default filters and make sure is from in the filters sent from the parent component
    const isValid = this.filterService.isDefaultFiltersValid(
      this.filterService.getDefaultFilters(),
      this.filters,
    );

    if (Object.keys(this.filterService.getDefaultFilters()).length && isValid) {
      const defaultFilterKeys = Object.keys(this.filterService.getDefaultFilters());

      this.selectedFilterId = defaultFilterKeys[0];
      this.selectedFilter = this.filterService.activeFiltersMap;
      this.selectedFilterIdChanged = defaultFilterKeys[0];

      const matchingDefaults = Object.values(this.filters).filter((filter) =>
        defaultFilterKeys.includes(filter.id),
      );

      this.selectFilter(matchingDefaults[0]);
    } else {
      this.selectFilter(this.filters[0]);
    }
  }

  isFilterApplied(filter: BaseFilter): boolean {
    return !!this.selectedFilter[filter.id]?.isApplied;
  }

  selectedFilterIdChanged: string | null = null;

  selectFilter(filter: BaseFilter): void {
    if (!filter) return;

    if (!this.selectedFilter[filter.id]) {
      this.selectedFilter[filter.id] = {
        filter,
        isApplied: false,
        value: filter.type === 'range' ? { min: 0, max: 1 } : null,
      };
    }

    if (this.selectedFilterId !== filter.id) {
      this.selectedFilterIdChanged = null; // Reset to force destruction

      setTimeout(() => {
        this.selectedFilterIdChanged = filter.id; // Set to new id, recreates component
      }, 0);

      this.selectedFilterId = filter.id;
    }
  }

  onFilterChange(event: { filter: AppliedFilter }): void {
    const filter = event.filter;
    this.selectedFilter[filter.filter.id] = filter;
    this.applyFilters.emit(Object.values(this.selectedFilter).filter((f) => f.isApplied));
  }

  search() {
    this.emitSearch.emit();
  }
}
